var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEuropeanUnion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    width: 409,
    height: 409,
    viewBox: "0 0 409 409",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2442_9217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.9 409.4C245.6 409.4 162.4 409.4 79.1002 409.4C76.6002 408.6 73.9002 408.7 71.3002 408.5C59.1002 407.7 48.5002 402.3 38.7002 395.7C21.9002 384.4 10.1002 369 3.3002 349.8C1.2002 343.9 1.4002 337.8 0.600197 331.8C0.500197 331.3 0.600195 330.7 0.200195 330.3C0.200195 246.8 0.200195 163.2 0.200195 79.7C1.0002 77.1 0.900197 74.5 1.1002 71.9C2.5002 56.6 9.8002 44 19.1002 32.3C29.8002 18.9 43.6002 9.70003 59.7002 3.80003C67.8002 0.800029 76.3002 0.40002 84.8002 0.40002C164.6 0.20002 244.4 0.300029 324.2 0.300029C352.5 0.300029 374.3 12.8 391.6 34.3C398.2 42.5 402.8 51.7 406.3 61.6C409 69.3 409.2 77.5 409.3 85.5C409.4 165.3 409.5 245.1 409.3 324.9C409.2 359.3 391.7 383.4 362.9 400.4C353.1 406.2 342.4 408.9 331 409.1C330.1 409 329.5 409 328.9 409.4Z",
    fill: "#41479A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.1 298.8L210.2 311.4H223.4L212.7 319.1L216.8 331.7L206.1 324L195.4 331.7L199.4 319.1L188.7 311.4H202L206.1 298.8Z",
    fill: "#FDE05A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.7 281.6L266.8 294.2H280.1L269.3 301.9L273.4 314.5L262.7 306.7L252 314.5L256.1 301.9L245.4 294.2H258.6L262.7 281.6Z",
    fill: "#FDE05A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.1 281.6L157.2 294.2H170.4L159.7 301.9L163.8 314.5L153.1 306.7L142.4 314.5L146.5 301.9L135.7 294.2H149L153.1 281.6Z",
    fill: "#FDE05A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.9 241.4L307 254H320.2L309.5 261.8L313.6 274.4L302.9 266.6L292.2 274.4L296.3 261.8L285.6 254H298.8L302.9 241.4Z",
    fill: "#FDE05A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.8 241.4L116.9 254H130.2L119.5 261.8L123.6 274.4L112.8 266.6L102.1 274.4L106.2 261.8L95.5 254H108.8L112.8 241.4Z",
    fill: "#FDE05A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.9 189L320 201.6H333.2L322.5 209.4L326.6 222L315.9 214.2L305.2 222L309.3 209.4L298.5 201.6H311.8L315.9 189Z",
    fill: "#FDE05A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5001 189L100.6 201.6H113.8L103.1 209.4L107.2 222L96.5001 214.2L85.8001 222L89.9001 209.4L79.1001 201.6H92.4001L96.5001 189Z",
    fill: "#FDE05A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.9 131.7L307 144.3H320.2L309.5 152.1L313.6 164.7L302.9 156.9L292.2 164.7L296.2 152.1L285.5 144.3H298.8L302.9 131.7Z",
    fill: "#FDE05A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.9 131.7L116.9 144.3H130.2L119.5 152.1L123.6 164.7L112.9 156.9L102.1 164.7L106.2 152.1L95.5 144.3H108.8L112.9 131.7Z",
    fill: "#FDE05A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.7 91.6L266.8 104.2H280.1L269.4 111.9L273.5 124.5L262.7 116.7L252 124.5L256.1 111.9L245.4 104.2H258.7L262.7 91.6Z",
    fill: "#FDE05A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.1 91.6L157.2 104.2H170.4L159.7 111.9L163.8 124.5L153.1 116.7L142.4 124.5L146.5 111.9L135.7 104.2H149L153.1 91.6Z",
    fill: "#FDE05A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.1 79.3L210.2 91.9001H223.4L212.7 99.7001L216.8 112.3L206.1 104.5L195.4 112.3L199.5 99.7001L188.7 91.9001H202L206.1 79.3Z",
    fill: "#FDE05A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2442_9217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 409,
    height: 409,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuropeanUnion);
export default __webpack_public_path__ + "static/media/european-union.00c73ae1493503231d47889f45565ca4.svg";
export { ForwardRef as ReactComponent };